import React, { useEffect, useState } from "react";
import VendorPriceRow from "./VendorPriceRow";
import ServiceLevelPriceUpdate from "./ServiceLevelPriceUpdate";
import { formatCurrency } from "../../../helpers/getSymbolFromCurrency";
import { getCtripCarType, isOfferRateUpdatable } from "./ctripCarTypes";
import { resolveMobioRateContext } from "./airportRatesUtils";

const ServiceLevelCard = ({
  offer,
  currency,
  fleetFilters,
  airportDetails,
  tripType,
}) => {
  const displayCurrency = offer.availableRates?.[0]?.currency || currency;
  const [displayPriceFrom, setDisplayPriceFrom] = useState(offer.displayPriceFrom);
  const carType = getCtripCarType(offer.categoryId);
  const canUpdatePrice = isOfferRateUpdatable(offer.categoryId);
  const mobioRateContext = resolveMobioRateContext({
    offer,
    fleetFilters,
    airportDetails,
    tripType,
    currency: displayCurrency,
  });

  useEffect(() => {
    setDisplayPriceFrom(offer.displayPriceFrom);
  }, [offer.displayPriceFrom]);

  return (
    <div className="rate-analysis-service-card">
      <div className="rate-analysis-service-header">
        <div className="rate-analysis-service-vehicle">
          <div className="rate-analysis-service-tier-badge">
            {offer.categoryId}
          </div>
          <div className="rate-analysis-service-meta">
            <h3 className="rate-analysis-service-name">{offer.tierName}</h3>
            {offer.vehicleDescription && (
              <p className="rate-analysis-service-desc">
                {offer.vehicleDescription}
              </p>
            )}
            <div className="rate-analysis-capacity">
              <span>{offer.capacity?.seats} passengers</span>
              <span className="rate-analysis-capacity-divider">|</span>
              <span>{offer.capacity?.bags} bags</span>
              {carType && (
                <>
                  <span className="rate-analysis-capacity-divider">|</span>
                  <span className="rate-analysis-car-type-tag">{carType}</span>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="rate-analysis-service-from">
          <p className="rate-analysis-from-label">From</p>
          <p className="rate-analysis-from-price">
            {formatCurrency(displayCurrency, displayPriceFrom)}
          </p>
        </div>
      </div>

      <div className="rate-analysis-vendor-list">
        {offer.availableRates.map((rate) => (
          <VendorPriceRow key={rate.productId} rate={rate} />
        ))}
      </div>

      {canUpdatePrice && (
        <ServiceLevelPriceUpdate
          offer={offer}
          carType={carType}
          currency={displayCurrency}
          tripPrice={displayPriceFrom}
          airportName={mobioRateContext.airportName}
          rateDescription={mobioRateContext.rateDescription}
          mobioRateValue={mobioRateContext.mobioRateValue}
          rateType={mobioRateContext.rateType}
          mobioRate={mobioRateContext.mobioRate}
          airportId={mobioRateContext.airportId}
          polygonId={mobioRateContext.polygonId}
          fromAirport={mobioRateContext.fromAirport}
        />
      )}
    </div>
  );
};

export default ServiceLevelCard;
